import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSEO } from "../lib/useSEO";
import { Container, SectionHeading, CTAButton, Eyebrow, Reveal } from "../components/site/ui";
import { User, Linkedin } from "lucide-react";

export default function Company() {
  const { t, lang } = useLang();
  const c = t.company;
  useSEO({ title: c.metaTitle, description: c.metaDesc, path: "/company", lang });

  return (
    <div>
      <section className="pt-28 pb-16 border-b border-cool-dark" data-testid="company-hero">
        <Container><SectionHeading eyebrow={c.eyebrow} title={c.title} /></Container>
      </section>

      <section className="py-20 border-b border-cool-dark" data-testid="company-mission">
        <Container className="grid lg:grid-cols-[0.4fr_1fr] gap-8">
          <Eyebrow>{c.missionLabel}</Eyebrow>
          <p className="text-2xl md:text-3xl font-display text-white leading-snug border-l-2 border-cyan pl-6">{c.mission}</p>
        </Container>
      </section>

      <section className="py-20 border-b border-cool-dark bg-nb-deep" data-testid="company-founder">
        <Container>
          <Eyebrow>{c.founderLabel}</Eyebrow>
          <Reveal className="mt-6">
            <div className="grid md:grid-cols-[auto_1fr] gap-8 items-start border border-cool-dark bg-nb-base p-8 max-w-4xl">
              <div className="w-24 h-24 border border-cyan flex items-center justify-center bg-nb-light shrink-0">
                <User size={40} className="text-cyan" strokeWidth={1.2} />
              </div>
              <div>
                <h3 className="font-display text-2xl text-white">{c.founderName}</h3>
                <div className="text-cyan font-mono text-sm mt-1">{c.founderRole}</div>
                <p className="mt-4 text-cool-light leading-relaxed">{c.founderBio}</p>
                <a
                  href="https://www.linkedin.com/in/silviociabarra/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="founder-linkedin"
                  className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-cyan hover:text-white transition-colors duration-200"
                >
                  <Linkedin size={16} strokeWidth={1.8} />
                  {c.linkedinLabel}
                </a>
              </div>
            </div>
          </Reveal>
          <p className="mt-6 text-sm text-cool-mid max-w-2xl">{c.teamNote}</p>
        </Container>
      </section>

      <section className="py-24" data-testid="company-cta">
        <Container><CTAButton to="/contact" variant="primary" testId="company-cta-btn">{t.common.talkUseCase}</CTAButton></Container>
      </section>
    </div>
  );
}
